import React from "react";

const Services = () => {
    return(
        <>
            <h1>
            HELLOOOOOOOOOOOOOO SERVICES PAGE
            </h1>
        </>
    );
}

export default Services